import { render } from "./UnitOverview.vue?vue&type=template&id=41c6bdcb&scoped=true"
import script from "./UnitOverview.vue?vue&type=script&lang=js"
export * from "./UnitOverview.vue?vue&type=script&lang=js"

import "./UnitOverview.vue?vue&type=style&index=0&id=41c6bdcb&scoped=true&lang=css"

import exportComponent from "../../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-41c6bdcb"]])

export default __exports__